import { IDropdownOption, ISelectableOption } from '@fluentui/react';
import { Dropdown } from '@eta/components';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './RoleSelector.scss';

export type RoleType = 'admin' | 'user' | 'custom';

export interface RoleSelectorProps {
    className?: string;
    selection: RoleType;
    onSelect: (documentSubType: RoleType | undefined) => void;
    readOnly?: boolean;
}

interface RenderItemProps {
    title: string | undefined;
    content: string | undefined;
}

const RenderItem: FC<RenderItemProps> = (props: RenderItemProps) => {
    const { title, content } = props;
    return (
        <>
            <span className="rolesItemRender bold">{title ?? ''}</span>
            <br />
            <span className="rolesItemRender">{content ?? ''}</span>
        </>
    );
};

export const RoleSelector: FC<RoleSelectorProps> = (
    props: RoleSelectorProps
) => {
    const { t } = useTranslation(['InviteUser']);
    const { selection, onSelect, className, readOnly } = props;

    const RoleLookups = [
        {
            key: 'admin',
            text: t('adminRoleTitle'),
            data: { title: t('admin') },
        },
        {
            key: 'user',
            text: t('userRoleTitle'),
            data: { title: t('user') },
        },
        {
            key: 'custom',
            text: t('customRoleTitle'),
            data: { title: t('custom') },
        },
    ];

    const onRenderTitle = (
        ddProps: IDropdownOption[] | undefined,
        df?: (renderProps: IDropdownOption[] | undefined) => JSX.Element | null
    ) => {
        if (ddProps) {
            return (
                <RenderItem
                    title={ddProps[0].data?.title}
                    content={ddProps[0].text}
                />
            );
        }
        if (df) {
            return df(ddProps);
        }
        return null;
    };

    const onRenderOption = (
        ddProps: ISelectableOption | undefined,
        df?: (renderProps: ISelectableOption | undefined) => JSX.Element | null
    ) => {
        if (ddProps) {
            return (
                <div className="rolesOptionRender">
                    <RenderItem
                        title={ddProps?.data?.title}
                        content={ddProps?.text}
                    />
                </div>
            );
        }
        if (df) {
            return df(ddProps);
        }
        return null;
    };

    const onRenderItem = (
        ddProps: ISelectableOption | undefined,
        df?: (renderProps: ISelectableOption | undefined) => JSX.Element | null
    ) => {
        if (df) {
            return <div className="rolesSelectorWrapper">{df(ddProps)}</div>;
        }
        return null;
    };

    return (
        <Dropdown
            label={t('role')}
            required
            containerClassName={clsx(className, 'rolesSelectorDropDown')}
            callOutWidth="Fixed"
            options={RoleLookups}
            onRenderTitle={onRenderTitle}
            onRenderOption={onRenderOption}
            onRenderItem={onRenderItem}
            selectedKey={selection}
            onChange={(_, option) => {
                onSelect(option?.key as RoleType);
            }}
            disabled={readOnly}
        />
    );
};
